export default "__VITE_ASSET__Boy6s_6U__"